import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { ToxnotSignInRequiredComponent } from '../BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { ToxnotComponentProperties } from '../BaseApplicationComponents/ToxnotComponent';
import { InventoryQuestionnaireType, NavContext, SurveyResponseState } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates';
import { QuestionnairePageType, ResponseBomType, SurveyPageType } from '../../../store/Models/Surveys/SurveyDataModel';
import React, { useEffect, useState } from 'react';
import SurveySidemenuStatus from '../SurveySidemenuStatus';
import { TeamRole } from '../../../store/Models/UserContext';

import "./styles.css";
import {
    coreValues,
    surveyResponseMaterialsPerPage
} from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { CoreSurveyResponseData } from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';

interface LocalProps {
    onNavigation: () => void;
}

type SurveySidemenuProps =
    ToxnotComponentProperties &
    typeof SurveyResponseController.actionCreators &
    SurveyResponseState &
    LocalProps;

class SurveySidemenu extends ToxnotSignInRequiredComponent<SurveySidemenuProps> {
    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    protected renderConcreteComponent(): JSX.Element | null {
        const supplierLevelQuestionnaire = SurveyResponseController.getSupplierLevelQuestionnaire();
        const originalRequestInventoryList = SurveyResponseController.getOriginalRequestMaterialInventoryList();
        const mainInventoryList = SurveyResponseController.getMainSupplierFacingMaterialInventoryList();

        const startMaterialIndex = this.props.navContext.currentPageOfMaterialsIndex * surveyResponseMaterialsPerPage;
        const lastMaterialIndex = startMaterialIndex + surveyResponseMaterialsPerPage - 1;

        const paginationDetails = coreValues(this.props.coreData);
        const totalInventories = paginationDetails.totalInventories;
        const totalPages = paginationDetails.totalPages;
        const totalInventoriesAfterGrouping = paginationDetails.totalInventoriesAfterGrouping;
        const hasGroups = paginationDetails.hasGroups;

        return (
            <>
                <div className={`survey-sidemenu-links ${totalInventories > surveyResponseMaterialsPerPage ? "survey-sidemenu-links-paginated" : "survey-sidemenu-links-normal"}`}>
                    <a onClick={() => this.selectMainPage(SurveyPageType.Instructions)}
                        className={`sidemenu-link instructions-link p-relative ${this.props.navContext.mainNavIndex === SurveyPageType.Instructions ? "active" : ""}`}
                        type="button">
                        <SurveySidemenuStatus statusToRender={true} isIncomplete={false} />
                        <span className="page-name">{this.localizeString("Instructions")}</span>
                    </a>
                    {supplierLevelQuestionnaire && (!this.props.coreData?.response.isRevisionResponse || supplierLevelQuestionnaire.revisionRequest != null) &&
                        <a onClick={() => this.selectSupplierQuestionnairePage()}
                            className={`sidemenu-link p-relative ${this.props.navContext.mainNavIndex === SurveyPageType.SupplierQuestionnaire ? "active" : ""}`}
                            type="button">
                            <SurveySidemenuStatus statusToRender={this.props.validationResult.supplierQuestionnaireStatus} isIncomplete={false}></SurveySidemenuStatus>
                            <span className="page-name">{this.localizeString("Company-level Questionnaire")}</span>
                        </a>
                    }
                    {this.props.coreData?.response?.bomType === ResponseBomType.Open &&
                        <a onClick={() => this.selectMainPage(SurveyPageType.AddMaterials, -1, 0)}
                            className={`sidemenu-link p-relative ${this.props.navContext.mainNavIndex === SurveyPageType.AddMaterials ? "active" : ""}`}
                            type="button">
                            <SurveySidemenuStatus
                                statusToRender={mainInventoryList.length > 0} isIncomplete={false}></SurveySidemenuStatus>
                            <span className="page-name">{this.localizeString("Add Materials")}</span>
                        </a>
                    }
                    {(originalRequestInventoryList.length > 0) && (totalInventories > 1) && (mainInventoryList.length >= SurveyResponseController.materiaListSizeGroupThreshold || this.props.coreData?.response?.groupedResponseInventories && Object.values(this.props.coreData?.response?.groupedResponseInventories).length > 0) &&
                        <a onClick={() => this.selectMainPage(SurveyPageType.GroupInventories)}
                            className={`sidemenu-link p-relative ${this.props.navContext.mainNavIndex === SurveyPageType.GroupInventories ? "active" : ""}`}
                            type="button">
                            <SurveySidemenuStatus statusToRender={true} isIncomplete={false}></SurveySidemenuStatus>
                            <span className="page-name">{this.localizeString("Material Groups")}</span>
                        </a>
                    }
                    {(mainInventoryList.length >= SurveyResponseController.materalListSizeBatchAnswerThreshold && totalInventories > 1)
                        ? <a onClick={() => this.selectMainPage(SurveyPageType.Batch)}
                            className={`sidemenu-link p-relative ${this.props.navContext.mainNavIndex === SurveyPageType.Batch ? "active" : ""}`}
                            type="button">
                            <SurveySidemenuStatus statusToRender={true} isIncomplete={false}></SurveySidemenuStatus>
                            <span className="page-name">{this.localizeString("Bulk Inputs")}</span>
                        </a>
                        : null
                    }
                    {/* // large-surveys // should only list the current page and needs a prev/next page button*/}
                    {(originalRequestInventoryList.length > 0) && (
                        <div className="survey-sidemenu-products-wrapper">
                            {mainInventoryList.map(
                                (inventory, invIndex) => {
                                    /*if ((invIndex < startMaterialIndex) || (invIndex > lastMaterialIndex)) {
                                        return null;
                                    }*/

                                    return (
                                        <React.Fragment key={inventory.inventoryId}>
                                            <a onClick={async () => await this.selectInventory(invIndex)}
                                                className={`sidemenu-link inventory-link p-relative inventory-element ${this.isInventoryPageSelected(inventory.inventoryId) ? "active" : ""}`}
                                                type="button">
                                                <SurveySidemenuStatus statusToRender={this.getInventoryStatus(inventory.inventoryId)}
                                                    isIncomplete={this.getInventoryPendingStatus(inventory.inventoryId)}
                                                    validationType={inventory.inventoryValidationStatus}
                                                    key={`status-${inventory.inventoryId}`}/>
                                                <span title={inventory.name} className="page-name">{inventory.name}</span>
                                               
                                            </a>
                                            {(this.props.selectedInventory?.inventoryId === inventory.inventoryId) &&
                                                <div className="survey-sidemenu-submenu-wrapper">
                                                    {this.props.selectedInventory.hasBomPage &&
                                                        <a onClick={() => this.selectBomPage(invIndex)}
                                                            className={`sidemenu-link inventory-link p-relative bom-data-identifier ${this.isBomPageSelected(inventory.inventoryId) ? "active" : ""}`}
                                                            type="button">
                                                            <SurveySidemenuStatus statusToRender={this.getInventoryBomStatus(inventory.inventoryId)}
                                                                isIncomplete={this.getInventoryBomNotesStatus(inventory.inventoryId)}
                                                                validationType={inventory.inventoryValidationStatus} />
                                                            <span title={this.localizeString("Ingredient Disclosure Data")} className="page-name">{this.localizeString("Ingredient Disclosure Data")}</span>
                                                        </a>
                                                    }
                                                    {this.props.surveyQuestionnairesList.map((questionnaire, questionnaireIndex) => (
                                                        questionnaire.pages.map((page, pageIndex) => (
                                                            <a onClick={async () => await this.selectSubInventory(invIndex, questionnaireIndex, pageIndex)} key={`${questionnaireIndex}-${pageIndex}`}
                                                                className={`sidemenu-link inventory-link p-relative ${this.isSubInventoryPageSelected(invIndex, questionnaireIndex, pageIndex) ? "active" : ""}`}
                                                                type="button">
                                                                <SurveySidemenuStatus statusToRender={this.getInventoryPageStatus(inventory.inventoryId, page.type, page.title, questionnaireIndex)}
                                                                    isIncomplete={this.getInventoryAnswerStatus(inventory.inventoryId, questionnaireIndex, page.type, page.title)}
                                                                    validationType={this.props.selectedInventory?.validationType}
                                                                    key={`substatus-${inventory.inventoryId}-${questionnaireIndex}-${pageIndex}`}/>
                                                                <span title={this.localizeString(page.title)} className="page-name">{this.localizeString(page.languageToTitleMap[this.props.insActiveLanguage] ?? page.title)}</span>
                                                            </a>
                                                        ))
                                                    ))}
                                                </div>
                                            }
                                        </React.Fragment>
                                    )
                                }
                            )}
                        </div>
                    )}
                </div>
                <div className="survey-progress-sidemenu-submit-wrapper p-t-15">
                    {totalInventories > surveyResponseMaterialsPerPage && (
                        <>
                            <div className="pagination-counter">
                                {!hasGroups ? (
                                    // When totalInventories equals totalInventoriesAfterGrouping
                                    `${startMaterialIndex + 1}-${lastMaterialIndex + 1} ${this.localizeString("of")} ${totalInventories} ${this.localizeString("materials")}`
                                ) : (
                                    // When totalInventories is not equal to totalInventoriesAfterGrouping
                                    `${startMaterialIndex + 1}-${lastMaterialIndex + 1} ${this.localizeString("of")} ${totalInventoriesAfterGrouping} ${this.localizeString("items")} (${totalInventories} ${this.localizeString(" materials total")})`
                                )}
                            </div>
                            <div className="pagination-controls">
                                {/* First Page Button */}
                                <button
                                    type="button"
                                    className="nav-button"
                                    onClick={async () => await this.goToPage(0)}
                                    disabled={this.props.navContext.currentPageOfMaterialsIndex === 0}
                                >
                                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" stroke="#026FA7"><g id="SVGRepo_bgCarrier" ></g><g id="SVGRepo_tracerCarrier" ></g><g id="SVGRepo_iconCarrier"> <path d="M16.929 4.99997L18.3432 6.41418L12.6863 12.071L18.3432 17.7279L16.929 19.1421L9.85789 12.071L16.929 4.99997Z" fill="#026FA7"></path> <path d="M8 19V4.99997H6V19H8Z" fill="#026FA7"></path> </g></svg>
                                </button>

                                {/* Previous Button */}
                                <button
                                    type="button"
                                    className="nav-button"
                                    onClick={async () => await this.goToPage(this.props.navContext.currentPageOfMaterialsIndex - 1)}
                                    disabled={this.props.navContext.currentPageOfMaterialsIndex === 0}
                                >
                                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" ><g id="SVGRepo_bgCarrier" ></g><g id="SVGRepo_tracerCarrier" ></g><g id="SVGRepo_iconCarrier"> <path d="M16.2431 6.34317L14.8288 4.92896L7.75781 12L14.8289 19.0711L16.2431 17.6569L10.5862 12L16.2431 6.34317Z" fill="#026FA7"></path> </g></svg>
                                </button>

                                {/* Current Page Input */}
                                <div className="parent-page-number-input">
                                    <input
                                        title="Click To Edit"
                                        type="number"
                                        className="page-number-input"
                                        placeholder={`${this.props.navContext.currentPageOfMaterialsIndex + 1}`}
                                        onFocus={(e) => {
                                            e.target.placeholder = '';
                                        }}
                                        onBlur={(e) => {
                                            e.target.placeholder = `${this.props.navContext.currentPageOfMaterialsIndex + 1}`;
                                            e.target.value = '';
                                        }}
                                        onKeyPress={async (e) => {
                                            if (e.key === 'Enter') {
                                                const input = e.target as HTMLInputElement;
                                                const page = parseInt((e.target as HTMLInputElement).value, 10) - 1;
                                                if (page >= 0 && page < (totalPages ?? 1)) {
                                                    this.goToPage(page);
                                                }
                                                else {
                                                    input.value = "";
                                                    input.placeholder = `${this.props.navContext.currentPageOfMaterialsIndex + 1}`;
                                                    input.blur();
                                                }
                                            }
                                        }}
                                        min="1"
                                        max={totalPages}
                                        aria-label="Current page"
                                    />
                                    <input title={`Total Pages: ${totalPages}`} type="text" className="page-number-input total-page-number-input" disabled value={` / ${totalPages}`} />
                                </div>
                                {/* Next Button */}
                                <button
                                    type="button"
                                    className="nav-button"
                                    onClick={async () => await this.goToPage(this.props.navContext.currentPageOfMaterialsIndex + 1)}
                                    disabled={this.props.navContext.currentPageOfMaterialsIndex + 1 === (totalPages)}
                                >
                                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" transform="rotate(180)"><g id="SVGRepo_bgCarrier" ></g><g id="SVGRepo_tracerCarrier" ></g><g id="SVGRepo_iconCarrier"> <path d="M16.2431 6.34317L14.8288 4.92896L7.75781 12L14.8289 19.0711L16.2431 17.6569L10.5862 12L16.2431 6.34317Z" fill="#026FA7"></path> </g></svg>
                                </button>

                                {/* Last Page Button */}
                                <button
                                    type="button"
                                    className="nav-button"
                                    onClick={async () => await this.goToPage((totalPages) - 1)}
                                    disabled={this.props.navContext.currentPageOfMaterialsIndex + 1 === (totalPages)}
                                >
                                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" stroke="#026FA7" transform="rotate(180)"><g id="SVGRepo_bgCarrier" ></g><g id="SVGRepo_tracerCarrier" ></g><g id="SVGRepo_iconCarrier"> <path d="M16.929 4.99997L18.3432 6.41418L12.6863 12.071L18.3432 17.7279L16.929 19.1421L9.85789 12.071L16.929 4.99997Z" fill="#026FA7"></path> <path d="M8 19V4.99997H6V19H8Z" fill="#026FA7"></path> </g></svg>
                                </button>
                            </div>
                        </>
                    )}
                    {(!this.hasResponseBeenSubmittedOrIsBeingSubmitted()) && // submitted=
                        <button disabled={(!SurveyResponseController.isOverallValid(this.props.validationResult) && this.props.coreData?.request?.requireValidationOnResponse)}
                            className={`btn w-100 ${(!SurveyResponseController.isOverallValid(this.props.validationResult) && this.props.coreData?.request?.requireValidationOnResponse) ? "btn-default" : "btn-toxnot-primary"} finalize-button`}
                            onClick={e => this.showModal("submit-survey-response-modal")}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={this.localizeString("Please complete all steps.")}
                            id="finalize-survey"
                        >
                            {this.localizeString("Finalize")}
                        </button>
                    }
                </div>
            </>
        )
    }

    private hasResponseBeenSubmittedOrIsBeingSubmitted = (): boolean => (
        this.props.coreData && this.props.coreData.response && (this.props.coreData.response.state === 1 || (this.props.coreData.response.responseDataJson && JSON.parse(this.props.coreData.response.responseDataJson).IsOfflineProcessStarted))
    );

    isAskingForAnySummaryData() {
        let dataRequested = this.props.coreData?.request?.dataRequested ?? null;

        if (dataRequested !== null)
            if (dataRequested.circularityDataAsked ||
                dataRequested.complianceList.length > 0 ||
                dataRequested.sustainabilityDataAsked ||
                dataRequested.documentsCertificationList.length)
                return true;

        return false;
    }

    getInventoryBomStatus(inventoryId: string) {
        const inventory = this.props.validationResult.bomStatusTable[inventoryId];

        return inventory?.fieldsStatus ?? false;
    }

    getInventoryBomNotesStatus(inventoryId: string) {
        const inventory = this.props.validationResult.bomStatusTable[inventoryId];
        return inventory?.inventoryBomValidation.length > 0;
    }

    getInventoryPageStatus(inventoryId: string, pageType: QuestionnairePageType | string, pageTitle: string | null = null, questionnaireIndex: number) {
        const inventory = this.props.validationResult.bomStatusTable[inventoryId];
        const currentQuestionnaireType = this.props.selectedInventory?.questionnairesTypes[questionnaireIndex]
        const page = SurveyResponseController.getCurrentPageForValidation(inventory, currentQuestionnaireType, pageType, pageTitle);


        return page?.pageIsComplete ?? false;
    }

    getInventoryAnswerStatus(inventoryId: string, questionnaireIndex: number, pageType: QuestionnairePageType | string, pageTitle: string | null = null) {
        const inventory = this.props.validationResult.bomStatusTable[inventoryId];
        const currentQuestionnaireType = this.props.selectedInventory?.questionnairesTypes[questionnaireIndex]
        const page = SurveyResponseController.getCurrentPageForValidation(inventory, currentQuestionnaireType, pageType, pageTitle);


        return (page?.answerIsRemaining) ?? false;
    }

    getInventoryStatus(id: string) {
        const inventory = this.props.validationResult.bomStatusTable[id];

        return inventory?.fieldsStatus === true &&
            inventory?.questionnaireStatus === true &&
            inventory?.circularityDataStatus === true &&
            inventory?.complianceDataStatus === true &&
            inventory?.documentsDataStatus === true &&
            inventory?.sustainabilityDataStatus === true &&
            inventory?.attestationQuestionnaireStatus === true;
    }
    getInventoryPendingStatus(id: string) {
        const inventory = this.props.validationResult.bomStatusTable[id];
        return inventory?.allValidationsPassed === false || this.getInventoryBomNotesStatus(id);
    }

    isBomPageSelected(inventoryId: string) {
        return this.props.navContext.mainNavIndex === SurveyPageType.Bom && inventoryId === this.props.selectedInventory?.inventoryId;
    }

    isInventoryPageSelected(inventoryId: string): boolean {
        return (this.props.navContext.mainNavIndex === SurveyPageType.Bom || this.props.navContext.mainNavIndex === SurveyPageType.Inventory) && this.props.selectedInventory?.inventoryId === inventoryId;
    }

    isSubInventoryPageSelected(inventoryIndex: number, questionnaireIndex: number, pageIndex?: number): boolean {
        if (pageIndex !== undefined) {
            return this.props.navContext.inventoryNavIndex === inventoryIndex && this.props.navContext.surveyQuestionnaireIndex === questionnaireIndex && this.props.navContext.surveyQuestionnairePageIndex === pageIndex;
        }

        return this.props.navContext.inventoryNavIndex === inventoryIndex && this.props.navContext.surveyQuestionnaireIndex === questionnaireIndex;
    }

    async selectInventory(invIndex: number) {
        this.props.setSurveySelectedInventory(invIndex);
        if (this.props.onNavigation !== null && this.props.onNavigation !== undefined) {
            this.props.onNavigation();
        }
    }

    selectSupplierQuestionnairePage() {
        this.props.setSurveySelectedSupplierQuestionnaire();

        if (this.props.onNavigation !== null && this.props.onNavigation !== undefined) {
            this.props.onNavigation();
        }
    }

    private async updateInventoryAfterBomUpdates() {
        if (this.props.selectedInventory?.hasBomPage) {
            this.props.dispatchLoadingState(true);
            let result = await SurveyResponseController.getInventoryDetails(this.props.responseId, this.props.selectedInventory?.inventoryId || "");
            this.props.dispatchUpdateInventoryDetails(result, this.props.selectedInventory?.inventoryId || '');
        }
    }
    async selectSubInventory(inventoryIndex: number, questionnaireIndex: number, questionnairePageIndex: number) {
        if (this.props.navContext.inventoryNavIndex === inventoryIndex && this.isBomPageSelected(this.props.selectedInventory?.inventoryId ?? '')) {
            await this.updateInventoryAfterBomUpdates();
        }

        this.props.setNavigationContext(SurveyPageType.Inventory, inventoryIndex, questionnaireIndex, questionnairePageIndex, this.props.navContext.previousPageStack);

        if (this.props.onNavigation !== null && this.props.onNavigation !== undefined) {
            this.props.onNavigation();
        }
    }

    selectBomPage(invIndex: number) {
        this.props.setSurveyBomPage(invIndex);

        if (this.props.onNavigation !== null && this.props.onNavigation !== undefined) {
            this.props.onNavigation();
        }
    }

    selectMainPage(pageType: SurveyPageType, questionnaireIndex?: number, questionnairePageIndex?: number) {
        this.props.setMainNavPage(pageType, questionnaireIndex, questionnairePageIndex);

        if (this.props.onNavigation !== null && this.props.onNavigation !== undefined) {
            this.props.onNavigation();
        }
    }
    private goToPage = async (pageIndex: number) => {
        this.props.getPaginatedSurveyData(pageIndex);

        if (this.props.onNavigation) {
            this.props.onNavigation();
        }
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(SurveySidemenu as any);
